var image_viewer_rtlignore_default = {
  "fontElementMap": "fOJxn",
  "imageFigure": "ZzA4I",
  "imageContainer": "H0CrF",
  "expandContainer": "-zhBF",
  "expandIcon": "_7lbuo",
  "pointer": "Bs8CH",
  "imageWrapper": "CFVIe",
  "imageRatio": "aFs0D",
  "image": "H5USt",
  "imageOverlay": "-ncGc",
  "imagePreload": "EF9ZD",
  "imageHighres": "_4mYPe",
  "onlyHighRes": "_2VVUa",
  "image_loading": "zuXlz"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
